import { render } from "./SvgIconContainer.vue?vue&type=template&id=2852b2d8"
import script from "./SvgIconContainer.vue?vue&type=script&lang=js"
export * from "./SvgIconContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__